import { memo, useMemo } from "react";
import './LanguageOption.css'

import { useResources } from "../../../Providers/ResourcesProvider/ResourceProvider";
import ResImg from "../../ResImg/ResImg";


function genLocalizationLangNames(localization) {

    const res = { 'en': 'UK' };

    for (const n in (localization || {})) {

        if (!res[n]) {

            const st = n.split('_');

            res[n] = (st.length === 1 ? n : st[1]).toUpperCase()

        }

    }

    return res;

}


export default memo(

    function LanguageOption({languageCode, className = "", ...props}) {
        const { localization, flags } = useResources();
        const langNames = useMemo(
            () => genLocalizationLangNames(localization),
            [localization]
        );
        const flag = flags?.[languageCode]

        return (

            <div className={`language-option ${className}`}>
                <ResImg info={flag}  aria-hidden={true}/>
                <span>{langNames?.[languageCode] ?? String(languageCode).toUpperCase()}</span>
            </div>

        )

    }


)